module.exports = __webpack_public_path__ + "img/brand-cases8.495c7df0.png";